import type { ConnectorCatalogItem } from 'containers/jobsiteConfiguration/tabs/connectors/connectorTypes';
import React from 'react';
import { connectorCatalog } from './connectorCatalog';

type ConnectorSetupDrawerProps = {
  isOpen: boolean;
  siteId: string;
  catalogItem: ConnectorCatalogItem;
  onClose: () => void;
  onCreated: () => Promise<unknown>;
  onBack: () => void;
};

export function ConnectorSetupDrawer({
  isOpen,
  siteId,
  catalogItem,
  onClose,
  onCreated,
  onBack,
}: ConnectorSetupDrawerProps): React.ReactElement {
  const { SetupDrawer } = connectorCatalog.getEntry(catalogItem.type);
  return (
    <SetupDrawer
      isOpen={isOpen}
      siteId={siteId}
      catalogItem={catalogItem}
      onClose={onClose}
      onCreated={onCreated}
      onBack={onBack}
    />
  );
}
